import React from "react";

export default function About(){
  return (
    <section id="about" className="section container">
      <h2 className="section-title">ABOUT ME</h2>
      <p>
      I am a Front-End React Developer specializing in building fast, intuitive, and scalable user interfaces.
With a strong foundation in JavaScript, React, and modern UI architecture, I focus on developing clean, maintainable code that leads to high-performance applications and exceptional user experiences.
I excel at translating design into pixel-perfect, responsive interfaces while ensuring seamless functionality through reusable components, efficient state management, and API-driven data workflows. My development approach centers on simplicity, clarity and performance creating products that are both robust and delightful to use.
Over the years, I’ve worked across diverse projects, improving UI efficiency, optimizing load times, and delivering polished front-end features using React, Redux, and modular CSS strategies. I’m passionate about problem-solving, continuous learning, and writing code that balances elegance with practicality.

      </p>
    </section>
  );
}